window.addEventListener('DOMContentLoaded', function() {
    var divs = document.querySelectorAll('body.template--product.gradient .multicolumn-card__info');
    var maxHeight = 0;

    // Find the maximum height among all divs
    divs.forEach(function(div) {
        maxHeight = Math.max(maxHeight, div.offsetHeight);
    });

    // Set the minimum height for all divs
    divs.forEach(function(div) {
        div.style.minHeight = maxHeight + 'px';
    });
});


let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
});


$(document).ready(function(){

  if (screen.width < 991) {
    if($('.icon-with-text-section .grid.grid--uniform').length > 0){ 
      $('.icon-with-text-section .grid.grid--uniform').slick({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              autoplay:true,
              autoplaySpeed: 3000
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              autoplay:true,
              autoplaySpeed: 3000
            }
          },
          {
            breakpoint: 589,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              autoplay:true,
              autoplaySpeed: 3000
            }
          }
        ]
      })
     }
   }


  if($('.image-text-slider-main').length > 0){
    $('.image-text-slider-main').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:true,
      prevArrow:"<img class='slider-prev' src='https://cdn.shopify.com/s/files/1/0748/2680/9625/files/fluent_arrow-right-12-regular.svg?v=1707372441' alt=''>",
      nextArrow:"<img class='slider-next' src='https://cdn.shopify.com/s/files/1/0748/2680/9625/files/fluent_arrow-right-12-regular_1.svg?v=1707372453' alt=''>"
    })
  }

  if($('.cart-drawer__collection.not-empty-cart .cstm-darwer-coll-inner').length > 0){
      if($('.cstm-darwer-coll-inner-main.slick-slide').length == 0){
        $('.cart-drawer__collection.not-empty-cart .cstm-darwer-coll-inner').slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:true,
          prevArrow:"<img class='slider-prev' src='https://cdn.shopify.com/s/files/1/0748/2680/9625/files/fluent_arrow-right-12-regular.svg?v=1707372441' alt=''>",
          nextArrow:"<img class='slider-next' src='https://cdn.shopify.com/s/files/1/0748/2680/9625/files/fluent_arrow-right-12-regular_1.svg?v=1707372453' alt=''>"
        })
      }
    }
  
  $(document).on('click','label.newsletter-form__button',function(){
    alert('vrfedsw');
    $('#myModal').attr('style','display:block');
    $(this).addClass('Modal-open');
  })

  $(document).on('click','.new-pop-btn label.button--primary , .new-pop-btn label.button--secondary',function(){
    $('.scnd-lay button.newsletter-form__button').trigger('click');
  })
  
  
  $(document).on('click','.modal-content .close',function(){
    $(this).parents('.text-colume-main').find('#myModal').attr('style','display:none !important');
    $('.grid__item.medium-up--one-third').removeClass('Modal-open');
  })

  $(document).on('change','.filter-main-all select',function(){
    var parent = $(this).parents('.filter-main-all').find('h2').text().trim().toLowerCase();
    var slct = $(this).val().toLowerCase();
    $('.facets__disclosure .facets__summary span').each(function(){
        var filterlabel = $(this).text().trim().toLowerCase();
        if( parent == filterlabel ){
          $(this).parents('.disclosure-has-popup.facets__disclosure').find('fieldset.facets-wrap.parent-wrap .facets-layout-list li label.facets__label').each(function(){
            var lbl = $(this).attr('data-attr');
            if(slct == lbl){
              $(this).trigger('click');
            }else if(slct == 'all products'){
              $('#FacetsWrapperDesktop .active-facets__button-wrapper a span').trigger('click');
            }
          })
        }
      })
    })

  $(document).on('click','a.active-facets__button-remove-cstm',function(e){
    e.preventDefault();
    $('#FacetsWrapperDesktop .active-facets__button-wrapper a span').trigger('click');
})
  
})